import { StoreAdapter } from "web-adapter-js";
import { filter, map } from "rxjs/operators";

const adapterChild = StoreAdapter.child;

export const getAdapterData = () => {
    return adapterChild.on().pipe(
        filter(({ stateApp }) => !!stateApp['headerNgData']),
        map(({ stateApp: { headerNgData } }) => headerNgData )
    );
}

export const getSuggestionData = () => {
    return adapterChild.on().pipe(
        filter(({ stateApp }) => !!stateApp['headerNgSuggestData']),
        map(({ stateApp: { headerNgSuggestData } }) => headerNgSuggestData )
    );
}

export const getConcurrentData = () => {
    return adapterChild.on().pipe(
        filter(({ stateApp }) => !!stateApp['headerNgConcurrentData']),
        map(({ stateApp: { headerNgConcurrentData } }) => headerNgConcurrentData )
    );
}

export const headerTrigger = (_type, action) => {
    const data = {}
    data['headerTriggers'] = {}
    data.headerTriggers[_type] = action
    adapterChild.dispatch(data);   
} 

export const headerSelectWithProps = (_type, action, item, source) => {
    const data = {}
    data['headerTriggers'] = {}
    data.headerTriggers[_type] = {action, item, source}
    adapterChild.dispatch(data);   
} 

export const headerSuggesterTrigger = (_type, action) => {
    const data = {}
    data['headerSuggesterTriggers'] = {}
    data.headerSuggesterTriggers[_type] = action
    adapterChild.dispatch(data);   
}  

export const ACTIONS = {
    NAVIGATE: 'navigate',
    CALL: 'call',
    SELECT: 'select',
    SEARCH: 'search',
    SEARCH_SUGGESTIONS: 'search_suggestions',
}

export const SELECT_OPTIONS = {
    SUGGESTION: 'SUGGESTION',
    STORE_TYPE: 'STORE_TYPE'
}

export const NAVIGATE_OPTIONS = {
    LOGIN : 'LOGIN',
    SIGN_UP : 'SIGN_UP',
    RAPPICREDITS : 'RAPPICREDITS',
    BACK : 'BACK',
    SPECIAL_BACK : 'SPECIAL_BACK',
    HOME : 'HOME',
    PRIME : 'PRIME' 
}

export const CALL_OPTIONS = {
    LOGOUT : 'LOGOUT',
    BASKET : 'BASKET',
    ADDRESS : 'ADDRESS',
    SEE_MORE_STORES : 'SEE_MORE_STORES',
    FREEZE_BG : 'FREEZE_BG',
    UNFREEZE_BG : 'UNFREEZE_BG'
}

export const SELECT_SOURCE = {
    GENERAL : 'GENERAL',
    RESTAURANT : 'RESTAURANT',
    STORE_TYPE : 'STORE_TYPE'
}